import { ExcalidrawLogo } from "@excalidraw/excalidraw/components/ExcalidrawLogo";
import { useI18n } from "@excalidraw/excalidraw/i18n";
import { WelcomeScreen } from "@excalidraw/excalidraw/index";
import React from "react";

export const AppWelcomeScreen: React.FC<{
  onCollabDialogOpen: () => any;
  isCollabEnabled: boolean;
}> = React.memo((props) => {
  const { t } = useI18n();
  const headingContent = (
    <>
      Pacdraw
      <br />
      Collaborative whiteboard
      <br />
      for cloud architecture and infra planning
    </>
  );

  return (
    <WelcomeScreen>
      <WelcomeScreen.Hints.MenuHint>
        {t("welcomeScreen.app.menuHint")}
      </WelcomeScreen.Hints.MenuHint>
      <WelcomeScreen.Hints.ToolbarHint />
      <WelcomeScreen.Hints.HelpHint />
      <WelcomeScreen.Center>
        <WelcomeScreen.Center.Logo>
          <ExcalidrawLogo withText text="PACDRAW" size="large" />
        </WelcomeScreen.Center.Logo>
        <WelcomeScreen.Center.Heading>
          {headingContent}
        </WelcomeScreen.Center.Heading>
        <WelcomeScreen.Center.Menu>
          <WelcomeScreen.Center.MenuItemLoadScene />
          <WelcomeScreen.Center.MenuItemHelp />
          {props.isCollabEnabled && (
            <WelcomeScreen.Center.MenuItemLiveCollaborationTrigger
              onSelect={() => props.onCollabDialogOpen()}
            />
          )}
          <WelcomeScreen.Center.MenuItemLink
            href="https://0xpacman.com"
            shortcut={null}
          >
            Visit 0xpacman.com
          </WelcomeScreen.Center.MenuItemLink>
          <WelcomeScreen.Center.MenuItemLink
            href="https://draw.0xpacman.com"
            shortcut={null}
          >
            Open draw.0xpacman.com
          </WelcomeScreen.Center.MenuItemLink>
        </WelcomeScreen.Center.Menu>
      </WelcomeScreen.Center>
    </WelcomeScreen>
  );
});
